import React from "react";
import "./LegalDocument.css";

function PrivacyPolicy() {
  return (
    <div className="legal-document">
      <section>
        <h2>1. Introduction</h2>
        <p>
          This Privacy Policy explains how we collect, use, and protect your
          personal information when you provide your phone number to receive
          RCS/SMS messages related to your restaurant reservations.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>When you make a reservation, we collect:</p>
        <ul>
          <li>Your phone number</li>
          <li>Reservation details (date, time, party size)</li>
          <li>Your name (if provided)</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <p>We use your phone number and reservation information solely for:</p>
        <ul>
          <li>Sending reservation confirmations via RCS/SMS</li>
          <li>Sending reservation modification confirmations</li>
          <li>Sending reservation cancellation confirmations</li>
          <li>Sending reservation confirmation requests</li>
          <li>
            Allowing restaurant staff to view your reservation history to
            provide better service
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Information Storage</h2>
        <p>
          Your information is stored securely in our database (MongoDB). We
          implement appropriate technical and organizational measures to protect
          your data against unauthorized access, alteration, or deletion.
        </p>
      </section>

      <section>
        <h2>5. Information Sharing</h2>
        <p>We do not:</p>
        <ul>
          <li>
            Sell your phone number or personal information to third parties
          </li>
          <li>
            Share your information with third parties for marketing purposes
          </li>
          <li>
            Use your information for any purpose other than managing your
            reservations
          </li>
        </ul>
        <p>We may share your information only:</p>
        <ul>
          <li>
            With Twilio, our RCS/SMS service provider, solely for delivering
            reservation-related messages
          </li>
          <li>If required by law or legal process</li>
          <li>To protect our rights or property</li>
        </ul>
        <p>
          <strong>Text Messaging Opt-In Data:</strong> All the above categories
          exclude text messaging originator opt-in data and consent; this
          information will not be shared with any third parties, excluding
          aggregators and providers of the Text Message services.
        </p>
      </section>

      <section>
        <h2>6. Data Retention</h2>
        <p>
          We retain your phone number and reservation information for as long as
          necessary to:
        </p>
        <ul>
          <li>Maintain your reservation history</li>
          <li>Provide you with reservation services</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section>
        <h2>7. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal information we hold about you</li>
          <li>Request correction of inaccurate information</li>
          <li>Request deletion of your information</li>
          <li>Opt out of RCS/SMS communications at any time</li>
        </ul>
        <p>
          To exercise these rights, please contact us using the information
          below.
        </p>
      </section>

      <section>
        <h2>8. Opting Out</h2>
        <p>You may opt out of receiving RCS/SMS messages by:</p>
        <ul>
          <li>Replying "STOP" to any message</li>
          <li>Contacting us directly at trattoriademi@gmail.com</li>
          <li>Requesting removal in person at our restaurant</li>
        </ul>
      </section>

      <section>
        <h2>9. Third-Party Services</h2>
        <p>
          We use Twilio to deliver RCS/SMS messages. Twilio's handling of your
          information is governed by their privacy policy, available at{" "}
          <a
            href="https://www.twilio.com/legal/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.twilio.com/legal/privacy
          </a>
        </p>
      </section>

      <section>
        <h2>10. Children's Privacy</h2>
        <p>
          Our reservation system is not intended for use by individuals under
          the age of 13. We do not knowingly collect information from children.
        </p>
      </section>

      <section>
        <h2>11. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify
          you of significant changes by posting the new policy with an updated
          "Last Updated" date.
        </p>
      </section>

      <section>
        <h2>12. Data Security</h2>
        <p>
          We implement industry-standard security measures to protect your
          information. However, no method of transmission over the internet is
          100% secure, and we cannot guarantee absolute security.
        </p>
      </section>

      <section>
        <h2>13. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy or wish to exercise
          your privacy rights, please contact us at:
        </p>
        <ul>
          <li>Email: trattoriademi@gmail.com</li>
          <li>Phone: +1(847)-332-2330</li>
          <li>Address: 1571 Sherman Ave, Evanston, IL, 60201</li>
        </ul>
      </section>

      <section>
        <h2>14. Compliance</h2>
        <p>
          <strong>GDPR Compliance:</strong> If you are located in the European
          Union, you have additional rights under the General Data Protection
          Regulation.
        </p>
        <p>
          <strong>CCPA Compliance:</strong> If you are a California resident,
          you have additional rights under the California Consumer Privacy Act.
        </p>
      </section>

      <p className="last-updated">Last Updated: 12/30/25</p>
    </div>
  );
}

export default PrivacyPolicy;
